import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { removeBrTag } from '../../helpers/ui';

import useStyles from './makeStyles';

const FormSection = ({ children, title, icon }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.formSection}>
      <div className={classes.formSectionHeader}>
        <div className={classes.formSectionIcon}>
          <img src={icon} alt="" className={classes.icon} />
        </div>
        <div className={classes.formSectionTitle}>{removeBrTag(t(title))}</div>
      </div>
      <div className={classes.formSectionContent}>{children}</div>
    </div>
  );
};

FormSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  icon: PropTypes.node.isRequired,
};

export default FormSection;
